import type { ComponentType } from 'react';
import QrCodeImport from 'react-qr-code';

export interface AspectlyQrCodeProps {
  value: string;
  size?: number;
  bgColor?: string;
  fgColor?: string;
  level?: 'L' | 'M' | 'H' | 'Q';
}

type QrComponent = ComponentType<AspectlyQrCodeProps>;

/**
 * Resolve the ``react-qr-code`` component across bundlers.
 *
 * TypeScript types only expose a default export, but Vite may surface CJS as a
 * namespace object ``{ default: { QRCode, default } }``. Named imports break ``tsc``.
 */
function resolveAspectlyQrCode(): QrComponent {
  const mod = QrCodeImport as unknown as QrComponent & {
    default?: QrComponent | { default?: QrComponent; QRCode?: QrComponent };
    QRCode?: QrComponent;
  };

  if (mod && typeof mod === 'object' && '$$typeof' in mod) {
    return mod as unknown as QrComponent;
  }

  const nested = mod?.default;
  if (nested && typeof nested === 'object' && '$$typeof' in nested) {
    return nested as unknown as QrComponent;
  }
  if (nested && typeof nested === 'object') {
    if (nested.default && typeof nested.default === 'object' && '$$typeof' in nested.default) {
      return nested.default as unknown as QrComponent;
    }
    if (nested.QRCode && typeof nested.QRCode === 'object' && '$$typeof' in nested.QRCode) {
      return nested.QRCode as unknown as QrComponent;
    }
  }
  if (mod?.QRCode && typeof mod.QRCode === 'object' && '$$typeof' in mod.QRCode) {
    return mod.QRCode as unknown as QrComponent;
  }

  throw new Error('react-qr-code component export not found');
}

export const AspectlyQrCode = resolveAspectlyQrCode();
